import { Box3, BoxGeometry, BufferGeometry, ExtrudeGeometry, Shape, Vector3 } from "three";
import { Model } from "oc-jaco3d/arrangement/Model";
import * as Commons from "oc-commons/Commons";
import * as Maths from "oc-commons/Maths";
import { MyModel3d } from "../arrangement3d/MyModel3d";
import { v3 } from "oc-threejs/short3";
import { MModelMaterialRelation } from "../../metamodell";

export class MyModel extends Model {
  // hier kommen die Vorgaben rein, die in  clippingParameters kopiert werden (achtung, nicht referenz gleich setzen!)
  defaultClippingParameters = {
    size: v3(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY),
    fixGridPosition: v3(0, 0, 0),
    gehrung45: false,
  };
  // clippingParameters werden aufgrund der generischen Natur nicht automatisch persistiert - hierzu Model ableiten
  clippingParameters = Commons.cloneDeep(this.defaultClippingParameters);

  createJaco3d(): MyModel3d {
    return new MyModel3d(this);
  }

  /** */
  getClippingGeometry(): BufferGeometry | ExtrudeGeometry {
    const s = this.getSizeCutted(0.0001);
    let geometry: BufferGeometry | ExtrudeGeometry;
    if (this.clippingParameters.gehrung45) {
      const shape = new Shape();
      const x2 = s.x / 2;
      const x3 = Math.max(s.x / 2 - s.y, 0);
      const y2 = s.y / 2;
      shape.moveTo(-x2, -y2);
      shape.lineTo(-x3, +y2);
      shape.lineTo(+x3, +y2);
      shape.lineTo(+x2, -y2);
      shape.lineTo(-x2, -y2);
      geometry = new ExtrudeGeometry(shape, {
        depth: s.z,
        steps: 1,
        bevelEnabled: false,
      });
      geometry.translate(0, 0, -0.5 * s.z);
    } else {
      geometry = new BoxGeometry(s.x, s.y, s.z);
      // BoxBufferGeometry erzeugt pro Material einen MaterialIndex. Damit die sich nicht bei der
      // Intersection übertragen, wird hiermit der MaterialIndex überall auf 0 gesetzt:
      geometry.groups = [];
    }
    const uncuttedBox = this.getBoxUnclipped();

    const fixGP = this.clippingParameters.fixGridPosition;
    const middleCutted = s.clone().multiplyScalar(0.5);
    const fixCutted = s.clone().multiply(fixGP);
    const fixUncutted = uncuttedBox.grid(fixGP);
    const t = fixUncutted.clone().sub(fixCutted).add(middleCutted);
    geometry.translate(t.x, t.y, t.z);
    return geometry;
  }

  /** */
  getSizeCutted(epsilon = 0): Vector3 {
    const uncuttedBox = this.getBoxUnclipped();
    const sizeUncutted = uncuttedBox.getSize(v3()).toArray();
    return v3().fromArray(
      this.clippingParameters.size
        .toArray()
        .map((c, i) => (Maths.notFinite(c) ? sizeUncutted[i] + epsilon : c))
    );
  }

  getMeta(): MModelMaterialRelation {
    return this.modelMaterialRelation;
  }

  get key(): string {
    return this.modelMaterialRelation.Objekt.Key;
  }

  getBoxUnclipped(): Box3 {
    return APP.modelsHelper.getBoundingBox(this.getMeta()).clone();
  }
}
